import { createFileRoute } from "@tanstack/react-router";
import { SolutionsIndex, SOLUTIONS_HUB_FAQ } from "./solutions";
import { SOLUTIONS } from "@/lib/site";
import { hubItemListNode } from "@/lib/hubSchema";
import { SECTION_OG, sectionImageMeta } from "@/lib/ogSections";
import { hreflangLinks } from "@/lib/hreflang";
import { pageSchemaScript } from "@/seo/schema";

const SOLUTIONS_TITLE = "Solutions — Security, Automation, Cinema & AV | Arif Khan";
const SOLUTIONS_DESC =
  "CCTV, access control, fire & life safety, gate automation, perimeter, smart automation, cinema and AV — engineered as one program across India.";

export const Route = createFileRoute("/solutions/")({
  component: SolutionsIndex,
  head: () => ({
    meta: [
      { title: SOLUTIONS_TITLE },
      { name: "description", content: SOLUTIONS_DESC },
      { property: "og:title", content: SOLUTIONS_TITLE },
      { property: "og:description", content: "CCTV, access control, fire & life safety, gate automation, perimeter, smart automation, cinema and AV — engineered as one program." },
      { property: "og:url", content: "https://arifkhanglobal.com/solutions" },
      ...sectionImageMeta(SECTION_OG.solutions, "Solutions by Arif Khan — integrated security, automation, cinema and AV"),
    ],

    links: [
      { rel: "canonical", href: "https://arifkhanglobal.com/solutions" },
      ...hreflangLinks("/solutions"),
      { rel: "alternate", type: "text/markdown", href: "https://arifkhanglobal.com/solutions.md", title: "Markdown mirror" },
    ],
    scripts: [
      pageSchemaScript(
        {
          path: "/solutions",
          type: "CollectionPage",
          name: SOLUTIONS_TITLE,
          description: SOLUTIONS_DESC,
          breadcrumb: [{ name: "Solutions", url: "/solutions" }],
        },
        [
          hubItemListNode({
            hubPath: "/solutions",
            listName: "Solutions by Arif Khan",
            items: SOLUTIONS.map((s) => ({
              name: s.title,
              url: `/solutions/${s.slug}`,
              description: s.short,
            })),
          }),
          {
            "@type": "FAQPage",
            "@id": "https://arifkhanglobal.com/solutions#faq",
            inLanguage: "en-IN",
            isPartOf: { "@id": "https://arifkhanglobal.com/solutions#webpage" },
            mainEntity: SOLUTIONS_HUB_FAQ.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          },
        ],
      ),
    ],
  }),
});
